import { FlexRow } from '@/components/common/Flex';
import { Fade, FlexProps, Spinner } from '@chakra-ui/react';
import { useStytchUser } from '@stytch/nextjs';
import NextLink from 'next/link';
import { FC } from 'react';
import { IconButton } from '../Button';
import PlentyLogo from '../PlentyLogo';

export type NavProps = FlexProps & {
    isAppLoading?: boolean;
    showLogo?: boolean;
};

const Nav: FC<NavProps> = ({ isAppLoading, showLogo = true, ...props }) => {
    const { isInitialized } = useStytchUser();

    return (
        <FlexRow
            w={'full'}
            py={4}
            align="center"
            justify="space-between"
            {...props}
        >
            <FlexRow align="center">
                {showLogo && (
                    <NextLink href="/" passHref legacyBehavior>
                        <IconButton
                            aria-label="home icon"
                            icon={<PlentyLogo />}
                            variant="ghost"
                            color="textDark"
                            onClickEvent="Plenty Logo Button Clicked"
                        />
                    </NextLink>
                )}

                <FlexRow mx={4} justify="center" align="center">
                    <Fade in={isAppLoading || !isInitialized}>
                        <Spinner
                            size="sm"
                            color="blue.500"
                            emptyColor="blue.100"
                            speed="0.75s"
                        />
                    </Fade>
                </FlexRow>
            </FlexRow>

            <FlexRow justify="flex-end" align="center" gap={4}></FlexRow>
        </FlexRow>
    );
};

export default Nav;
